import React, { memo, useEffect, useState } from "react";
import { Handle, Position } from "@xyflow/react";
import { MDBAutocomplete, MDBBtn, MDBIcon, MDBInput, MDBSpinner } from "mdb-react-ui-kit";
import { getMisc } from "../../apiclients/streamsapi_bridge";
import CFNodeUI from "./NodeUI";
export default memo(({ data, isConnectable }) => {
  const [isloading, setIsloading] = useState(true);
 
  function onDelete(id) {
    data.onDelete(id);
  }
  
  const [callerList, setCallerList] = useState([]);
  const [defaultData, setDefaultData] = useState([]);
  const [displayValuess, setDisplayValuess] = useState([]);
  const [selected, setSelected] = useState(
    data.selected_object ? data.selected_object.label : ""
  );
  console.log("data ::::: "+JSON.stringify(data));
  console.log("select Object ::::: "+JSON.stringify(data?.selected_object));
  console.log("label value :::::::::::; "+data?.selected_object?.label);
  const [customData, setCustomData] = useState(displayValuess);
  async function fetchAAMiscData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["directory"] }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    console.log( "table data :::::: " , JSON.stringify(tdata));
    if (!tdata) {
      window.alert(`info with id  not found`);
    }

    const directorylist = tdata?.misc?.directory_list?.directory ?? [];



    const mergeWithSortList = [...directorylist].sort(
      (a, b) => a?.title?.localeCompare(b?.title)
    );
    console.log(mergeWithSortList);
    setDefaultData(mergeWithSortList);
    setDisplayValuess(mergeWithSortList);
    setCustomData(displayValuess)
    console.log( "displayValuess:::::::::::::::::::::::::::::::::::"   , displayValuess)
    setDisplayValuess(mergeWithSortList);
    setIsloading(false);
  }

  

  useEffect(() => {
    if(data && data.selected_object) {
      setSelected(data.selected_object ? data.selected_object.label : "");
    }
  }, [data]);

  useEffect(() => {
    console.log("Directory data ::::" , JSON.stringify(data))
    fetchAAMiscData();
  }, []);
  
const onCustomSearch = (value) =>
    setCustomData(
      displayValuess.filter((item) =>
        (item.title.toLowerCase().includes(value.toLowerCase()) || (item.extension && item.extension.toString().includes(value.toLowerCase()))) // Added conditional check
      )
    );
  const handleFocus = (event) => {
    if (event.target.value != "") {
      event.target.select();
      setCustomData(displayValuess);
    }
  };

  return (
    <>
      <CFNodeUI
        headerClass="directoryNodeHeader"
        data={data}
        deletable={true}
        onDelete={onDelete}
        isConnectable={isConnectable}
        bodyContnent={
          <>
            <div >
              {/* <MDBAutocomplete
                // data={customData}
                displayValue={(item) => {
                    const subpart = item && `${item.title} : ${item.is_primary == 1 ? 'Primary' : (item.type == 1 ? 'Exclude' : 'Include')} Directory`
                  return `${subpart} `;
                }}
                placeholder={" Directory"}
                disabled= {true}
                value={selected}
                title={selected}



              /> */}
              <MDBInput
                id="form1"
                type="text"
                size="sm"
                value={selected}
                disabled = {true}
                displayValue={(item) => {
                  const subpart = item && `${item.title} : ${item.is_primary == 1 ? 'Primary' : (item.type == 1 ? 'Exclude' : 'Include')} Directory`
                return `${subpart} `;
              }}
    
            />
            </div>
          </>
        }
        targetNode={true}
      />
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
});
